export function hideCartModalShoppingContext(priceType) {
    let $defaultBannerOrderLabel = $('#defaultBannerOrderLabel');
    let $bannerOrderLabel = $('#bannerOrderLabel');

    if($defaultBannerOrderLabel.length && $bannerOrderLabel.length) {
        if(priceType.includes('Retail-Checkout')) {
            $defaultBannerOrderLabel.css('display', 'block'); // Make visible
            $bannerOrderLabel.css('display', 'none'); // Hide
        } else {
            $defaultBannerOrderLabel.css('display', 'none'); // Hide
            $bannerOrderLabel.css('display', 'block'); // Make visible
        }
    }
}
